/**
 * DM EOD Form - Public submission form
 * URL: /dm-eod
 *
 * Renders questions dynamically from the database config.
 */

import { DynamicEodForm } from "./DynamicEodForm";

export function DmEodForm() {
  return (
    <DynamicEodForm
      formType="dm"
      submitUrl="/api/eod/submit/dm"
      fallbackTitle="DM EOD Report"
      fallbackSubtitle="Fill out your daily DM setting report"
    />
  );
}

export default DmEodForm;
